(function (root, factory) {
  var utils = factory();

  if (typeof module === 'object' && module.exports) {
    module.exports = utils;
  }

  root.ElazComboUtils = utils;
}(typeof window !== 'undefined' ? window : globalThis, function () {
  'use strict';

  function hasAvailableVariant(product) {
    var variants = product && Array.isArray(product.variants) ? product.variants : [];

    return variants.some(function (variant) {
      return Boolean(variant && variant.available);
    });
  }

  function availableVariantById(product, id) {
    var variants = product && Array.isArray(product.variants) ? product.variants : [];

    if (id === null || id === undefined || id === '') {
      return null;
    }

    return variants.find(function (variant) {
      return variant && variant.available && String(variant.id) === String(id);
    }) || null;
  }

  function firstAvailableProductIndex(products) {
    var safeProducts = Array.isArray(products) ? products : [];

    return safeProducts.findIndex(hasAvailableVariant);
  }

  function createInitialSteps(quantity, products) {
    if (!Number.isInteger(quantity) || quantity <= 0) {
      throw new Error('quantity must be a positive integer');
    }

    var productIndex = firstAvailableProductIndex(products);

    if (productIndex === -1) {
      throw new Error('at least one available product is required');
    }

    return Array.from({ length: quantity }, function () {
      return { productIndex: productIndex, variantId: null };
    });
  }

  function stepsComplete(steps) {
    return Array.isArray(steps) && steps.length > 0 && steps.every(function (step) {
      return step && step.variantId !== null && step.variantId !== undefined
        && String(step.variantId).trim() !== '';
    });
  }

  function buildCartItems(variantIds, properties) {
    var quantities = new Map();
    var safeVariantIds = Array.isArray(variantIds) ? variantIds : [];

    safeVariantIds.forEach(function (variantId) {
      quantities.set(variantId, (quantities.get(variantId) || 0) + 1);
    });

    return Array.from(quantities, function (entry) {
      return {
        id: entry[0],
        quantity: entry[1],
        properties: properties,
      };
    });
  }

  function isComboInstanceId(value) {
    return value !== null && value !== undefined && String(value).trim() !== '';
  }

  function isComboItem(item) {
    return Boolean(item && item.properties && isComboInstanceId(item.properties._combo_instance_id));
  }

  function comboLineGroups(cart) {
    var items = cart && Array.isArray(cart.items) ? cart.items : [];

    return items.reduce(function (groups, item) {
      if (!isComboItem(item) || !isComboInstanceId(item.key)) {
        return groups;
      }

      var instanceId = String(item.properties._combo_instance_id);
      if (!Object.prototype.hasOwnProperty.call(groups, instanceId)) {
        groups[instanceId] = [];
      }
      groups[instanceId].push(String(item.key));
      return groups;
    }, Object.create(null));
  }

  function comboRemovalUpdates(cart, comboInstanceId) {
    var instanceId = isComboInstanceId(comboInstanceId) ? String(comboInstanceId) : null;
    var groups = comboLineGroups(cart);

    if (!instanceId || !Object.prototype.hasOwnProperty.call(groups, instanceId)) {
      return {};
    }

    return groups[instanceId].reduce(function (updates, key) {
      updates[key] = 0;
      return updates;
    }, {});
  }

  return {
    hasAvailableVariant: hasAvailableVariant,
    availableVariantById: availableVariantById,
    firstAvailableProductIndex: firstAvailableProductIndex,
    createInitialSteps: createInitialSteps,
    stepsComplete: stepsComplete,
    buildCartItems: buildCartItems,
    isComboInstanceId: isComboInstanceId,
    isComboItem: isComboItem,
    comboLineGroups: comboLineGroups,
    comboRemovalUpdates: comboRemovalUpdates,
  };
}));
